import { pushPlayerAction } from './actionlog.service';
import { api } from './api';

export interface IInteraction {
  _id?: string;
  player: string;
  sender: string;
  senderName: string;
  item: string;
  message?: string;
  like?: boolean;
  created: {
    $date: number;
  };
}

export async function registerInteraction(payload: IInteraction) {
  pushPlayerAction('registerInteraction', {
    endpoint: `database/interactions__c`,
    data: payload,
    method: 'PUT',
  });
  const { data } = await api.put<IInteraction[]>(`database/interactions__c`, payload);
  return data;
}

export async function deleteInteraction(id: string) {
  pushPlayerAction('deleteInteraction', {
    endpoint: `database/interactions__c?q=_id:'${id}'`,
    data: {
      id,
    },
    method: 'DELETE',
  });
  const { data } = await api.delete(`database/interactions__c?q=_id:'${id}'`);
  return data;
}
